export default __webpack_public_path__ + "static/media/pending.035550d8.svg";